import AuctionDetails from "../../AuctionListing/AuctionDetails";
import Details from "../../AuctionListing/Details";
import Icon from "../../AuctionListing/Icon";
import Image from "../../AuctionListing/Image";
import MapLocation from "../../AuctionListing/MapLocation";
import SellerDescription from "../../AuctionListing/SellerDescription";
import Container from "../../layout/Container";
import PopupCloseButton from "../Popuplayout/PopupCloseButton";

const AuctionListPopup = () => {
  return (
    <div className="scale-50">
      {" "}
      <Container>
        <PopupCloseButton />
        <Icon />
        <div className="flex items-start justify-between">
          <div>
            <Image />
            <Details />
          </div>
          <div>
            <AuctionDetails />
            <SellerDescription />
            <MapLocation />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default AuctionListPopup;
